import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import cx from 'classnames';

import ProfileSettings from './ProfileSettings';
import VehiclesSettings from './VehiclesSettings';
import Modal from '../index';
import { GeozoneCreatePage } from '../GeozonesModal/GeozoneCreatePage';

import { toggleSettingsModal, switchCurrentDevice } from '../actions';
import { formatNumber } from '../../../utils/helpers';

export const SETTINGS_MODAL_TYPES = ['profile', 'vehicles', 'geozones'];

@translate(['modal'], { wait: true })
class SettingsModal extends Modal {
  constructor(props) {
    super(props);

    this.state = {
      type: this.props.type || SETTINGS_MODAL_TYPES[0],
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentWillReceiveProps(props) {
    if (this.state.type !== props.type) {
      this.setState({
        type: props.type,
      });
    }
  }

  toggleModal(e, type) {
    e.preventDefault();
    this.props.toggleModal(type);
  }

  render() {
    const { devices, currentDevice, t } = this.props;
    return (
      <div id="popupPersonal1" className="popapWrapper popapDefaultWrapper active">
        <div ref="modal" className="popup">
          <a href="#close" onClick={e => this.toggleModal(e, '')} className="popup__close" />
          <div className="popup__aside">
            <div className="popup__aside__settings">
              <div className="popup__aside__settings__item">
                <div className="title">{`${this.props.profile.firstName || ''} ${this.props.lastName || ''}`}</div>
                <div className="popup__aside__settings__link">
                  <a
                    className={cx({ active: this.state.type === SETTINGS_MODAL_TYPES[0] })}
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({
                        type: SETTINGS_MODAL_TYPES[0],
                      });
                    }}
                    href=""
                  >{t('modal:personal__header')}</a>
                </div>
              </div>
              <div className="popup__aside_list">
                {
                  devices.map((device, i) => {
                    const activeDevice = currentDevice && currentDevice.id === device.id;
                    return (
                      <div key={device.id + i} className="popup__aside__settings__item">
                        <div className="title">{device.name}</div>
                        <div className="popup__aside__settings__code">
                          <div className="name">{formatNumber(device.packageId, 6)}</div>
                          <div className="status status-active">{t('modal:activated')}</div>
                        </div>
                        <div className="popup__aside__settings__link">
                          <a
                            className={cx({ active: this.state.type === SETTINGS_MODAL_TYPES[1] && activeDevice })}
                            onClick={(e) => {
                              e.preventDefault();
                              this.props.handleDeviceClick(device);
                              this.setState({
                                type: SETTINGS_MODAL_TYPES[1],
                              });
                            }}
                            href=""
                          >{t('modal:settings')}</a>
                        </div>
                      </div>
                    );
                  })
                }
              </div>
              {/* <div className="popup__aside__settings__more"><a href="">+ Подключить автомобиль</a></div> */}
            </div>
          </div>
          {
            this.state.type === SETTINGS_MODAL_TYPES[0] && <ProfileSettings />
          }
          {
            this.state.type === SETTINGS_MODAL_TYPES[1] && <VehiclesSettings />
          }
        </div>
        <a href="#close" onClick={this.toggleModal} className="overlay" />
      </div>
    );
  }
}

SettingsModal.propTypes = {
  vehicles: PropTypes.array,
  currentVehicle: PropTypes.object,
  toggleModal: PropTypes.func,
  handleDeviceClick: PropTypes.func,
  type: PropTypes.oneOf(SETTINGS_MODAL_TYPES),
  profile: PropTypes.object,
  devices: PropTypes.array,
};

export default connect(
  state => ({
    currentDevice: state.settings.currentDevice,
    vehicles: state.settings.vehicles,
    profile: state.settings.profile,
    currentVehicle: state.settings.currentVehicle,
    devices: state.devices.devices,
  }),
  dispatch => ({
    toggleModal(type) {
      return dispatch(toggleSettingsModal({ type }));
    },
    handleDeviceClick(device) {
      return dispatch(switchCurrentDevice({ device }));
    },
  }),
)(SettingsModal);



// WEBPACK FOOTER //
// ./src/components/Modal/SettingsModal/index.js